import React from 'react'
import { Text, View} from '@react-pdf/renderer';
import styles from './styles';
import { numberToCurrency } from '../../utils/numberToCurrency';
import { numberToWords } from '../../utils/numberToWords';

const PVContent = ({voucher}) => {
    return (
        <View style={styles.contentSection}>
            <View fixed style={styles.watermarkView}>
                <Text style={styles.watermark}> Mega Plaza</Text>
                <Text style={styles.watermark}> Mega Plaza</Text>
                <Text style={styles.watermark}> Mega Plaza</Text>
                <Text style={styles.watermark}> Mega Plaza</Text>
                <Text style={styles.watermark}> Mega Plaza</Text>
                <Text style={styles.watermark}> Mega Plaza</Text>
                <Text style={styles.watermark}> Mega Plaza</Text>
                <Text style={styles.watermark}> Mega Plaza</Text>
                <Text style={styles.watermark}> Mega Plaza</Text>
                <Text style={styles.watermark}> Mega Plaza</Text>
                <Text style={styles.watermark}> Mega Plaza</Text>
                <Text style={styles.watermark}> Mega Plaza</Text>
                <Text style={styles.watermark}> Mega Plaza</Text>
                <Text style={styles.watermark}> Mega Plaza</Text>
                <Text style={styles.watermark}> Mega Plaza</Text>
                <Text style={styles.watermark}> Mega Plaza</Text>
                <Text style={styles.watermark}> Mega Plaza</Text>
                <Text style={styles.watermark}> Mega Plaza</Text>
                <Text style={styles.watermark}> Mega Plaza</Text>
                <Text style={styles.watermark}> Mega Plaza</Text>
                <Text style={styles.watermark}> Mega Plaza</Text>
                <Text style={styles.watermark}> Mega Plaza</Text>
                <Text style={styles.watermark}> Mega Plaza</Text>
                <Text style={styles.watermark}> Mega Plaza</Text>
                <Text style={styles.watermark}> Mega Plaza</Text>
                <Text style={styles.watermark}> Mega Plaza</Text>
                <Text style={styles.watermark}> Mega Plaza</Text>
                <Text style={styles.watermark}> Mega Plaza</Text>
                <Text style={styles.watermark}> Mega Plaza</Text>
                <Text style={styles.watermark}> Mega Plaza</Text>
                <Text style={styles.watermark}> Mega Plaza</Text>
                <Text style={styles.watermark}> Mega Plaza</Text>
                <Text style={styles.watermark}> Mega Plaza</Text>
                <Text style={styles.watermark}> Mega Plaza</Text>
                <Text style={styles.watermark}> Mega Plaza</Text>
                <Text style={styles.watermark}> Mega Plaza</Text>
                <Text style={styles.watermark}> Mega Plaza</Text>
                <Text style={styles.watermark}> Mega Plaza</Text>
                <Text style={styles.watermark}> Mega Plaza</Text>
                <Text style={styles.watermark}> Mega Plaza</Text>
                <Text style={styles.watermark}> Mega Plaza</Text>
                <Text style={styles.watermark}> Mega Plaza</Text>
                <Text style={styles.watermark}> Mega Plaza</Text>
                <Text style={styles.watermark}> Mega Plaza</Text>
                <Text style={styles.watermark}> Mega Plaza</Text>
                <Text style={styles.watermark}> Mega Plaza</Text>
                <Text style={styles.watermark}> Mega Plaza</Text>
                <Text style={styles.watermark}> Mega Plaza</Text>
                <Text style={styles.watermark}> Mega Plaza</Text>
                <Text style={styles.watermark}> Mega Plaza</Text>
                <Text style={styles.watermark}> Mega Plaza</Text>
                <Text style={styles.watermark}> Mega Plaza</Text>
                <Text style={styles.watermark}> Mega Plaza</Text>
                <Text style={styles.watermark}> Mega Plaza</Text>
                <Text style={styles.watermark}> Mega Plaza</Text>

            </View>
            <View style={styles.contentView}>
                <View style={styles.infoView}>
                    <View style={styles.rowView}>
                        <Text style={styles.textTitle}>
                            Date:
                        </Text>
                        <Text style={styles.textContent}>
                            {voucher.voucherDateStr}
                        </Text>
                    </View>
                    <View style={styles.rowView}>
                        <Text style={styles.textTitle}>
                            Voucher Number:
                        </Text>
                        <Text style={styles.textContent}>
                            {voucher.voucherNo} {voucher.projectCount > 1 ? `(${voucher.projectVSNo} of ${voucher.projectCount})` : ''}
                        </Text>
                    </View>
                    <View style={styles.rowView}>
                        <Text style={styles.textTitle}>
                            Department:
                        </Text>
                        <Text style={styles.textContent}>
                            {voucher.dept}
                        </Text>
                    </View>
                    <View style={styles.rowView}>
                        <Text style={styles.textTitle}>
                            Section:
                        </Text>
                        <Text style={styles.textContent}>
                            {voucher.section}
                        </Text>
                    </View>
                    <View style={styles.rowView}>
                        <Text style={styles.textTitle}>
                            Location:
                        </Text>
                        <Text style={styles.textContent}>
                            {voucher.location}
                        </Text>
                    </View>
                    <View style={styles.rowView}>
                        <Text style={styles.textTitle}>
                            Project:
                        </Text>
                        <Text style={styles.textContent}>
                            {voucher.project}
                        </Text>
                    </View>
                    <View style={styles.rowView}>
                        <Text style={styles.textTitle}>
                            Payee:
                        </Text>
                        <Text style={styles.textContent}>
                            {voucher.payee}
                        </Text>
                    </View>
                    <View style={styles.rowView}>
                        <Text style={styles.textTitle}>
                            Payment Mode:
                        </Text>
                        <Text style={styles.textContent}>
                            {voucher.paymode}
                        </Text>
                    </View>
                    <View style={styles.rowView}>
                        <Text style={styles.textTitle}>
                            Account Details:
                        </Text>
                        <Text style={styles.textContent}>
                            {voucher.bank}  {voucher.acctno}
                        </Text>
                    </View>
                </View>
                <View style={styles.detailsView}>
                    <View style={styles.detailsTitleRow}>
                        <Text style={styles.detailsSNoColumn}>
                            S/No
                        </Text>
                        <Text style={styles.detailsDescColumn}>
                            Item Description
                        </Text>
                        <Text style={styles.detailsAmountColumn}>
                            Item Amount
                        </Text>
                    </View>
                    {voucher.itemDetails?.map((item, index) => (
                    <View wrap style={styles.detailsContentRow}>
                        <Text style={styles.detailsSNoColumn}>
                            {index + 1}
                        </Text>
                        <Text style={styles.detailsDescColumn}>
                            {item.itemdesc}
                        </Text>
                        <Text style={styles.detailsAmountColumn}>
                            {numberToCurrency(item.itemamount, false)}
                        </Text>
                    </View>
                    ))}
                    <View style={styles.detailsSummaryRow}>
                        <Text style={styles.detailsSNoColumn}>
                            
                        </Text>
                        <Text style={styles.detailsDescColumn}>
                            
                        </Text>
                        <Text style={styles.detailsAmountColumn}>
                            {numberToCurrency(voucher.totalAmount, true)}
                        </Text>
                    </View>
                </View>
                <View wrap={false} style={styles.approvalsView}>
                    <View style={styles.rowView}>
                        <Text style={styles.textTitle}>
                            Amount In Words:
                        </Text>
                        <Text style={styles.textContent}>
                            {numberToWords(voucher.totalAmount)}
                        </Text>
                    </View>
                
                    <View style={styles.rowView}>
                        <Text style={styles.textTitle}>
                            Prepared By:
                        </Text>
                        <Text style={styles.textContent}>
                            
                        </Text>
                    </View>

                    <View style={styles.rowView}>
                        <Text style={styles.textTitle}>
                            Authorized By:
                        </Text>
                        <Text style={styles.textContent}>
                            
                        </Text>
                    </View>

                    <View style={styles.rowView}>
                        <Text style={styles.textTitle}>
                            Approved By:
                        </Text>
                        <Text style={styles.textContent}>
                            
                        </Text>
                    </View>
                    <View style={styles.rowView}>
                        <Text style={styles.textTitle}>
                            Received By:
                        </Text>
                        <Text style={styles.textContent}>
                            
                        </Text>
                    </View>
                    <View style={styles.rowView}>
                        <Text style={styles.textTitle}>
                            Cashier / DOP:
                        </Text>
                        <Text style={styles.textContent}>
                            
                        </Text>
                    </View>
                    <View style={styles.rowView}>
                        <Text style={styles.textTitle}>
                            ACC HOD:
                        </Text>
                        <Text style={styles.textContent}>
                            
                        </Text>
                    </View>
                </View>
            </View>
        </View>
    )
}

export default PVContent
